import { render, staticRenderFns } from "./VMessage.vue?vue&type=template&id=f2b46870&scoped=true&"
import script from "./VMessage.vue?vue&type=script&lang=ts&"
export * from "./VMessage.vue?vue&type=script&lang=ts&"
import style0 from "./VMessage.vue?vue&type=style&index=0&id=f2b46870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b46870",
  null
  
)

export default component.exports